import { useContext } from 'react';
import { propOr } from 'ramda';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';
import { normalizeFundsBonusDetails } from '../../normalizers';
import { useBonusesStore } from '../../store';
import { useAllTypesBonuses } from '../allTypesBonuses';
import { useFundsBonuses } from '../fundsBonuses';
import { useFundsBonusesHistory } from '../fundsBonusesHistory';

const selectBonusDetails = () => propOr({}, 'bonusDetails');

export const useFundsBonus = (bonusId) => {
  const { bonuses = {} } = useOtherSettings();
  const { isShowServices = true, isShowMaxBonus = false } = bonuses;
  const fundsBonuses = useFundsBonuses();
  const fundsBonusesHistory = useFundsBonusesHistory();
  const bonusDetails = useBonusesStore(selectBonusDetails());
  const allTypesBonuses = useAllTypesBonuses();
  const { t, f } = useI18n();
  const [userData] = useContext(UserContext);

  const bonusData = bonusId
    ? [
        ...fundsBonuses,
        ...fundsBonusesHistory,
        ...Object.values(allTypesBonuses) // should be here for finding funds bonus when all bonuses in single list
      ].find(({ bonusId: bId }) => bId === bonusId)
    : bonusDetails;

  return normalizeFundsBonusDetails({
    bonusData,
    userData,
    t,
    f,
    isShowServices,
    isShowMaxBonus
  });
};
